import { useEffect } from 'react'
import { useFeatureFlagContext } from '../contexts/FeatureFlagContext'
import { featureFlagService } from '../services/featureFlagService'

export function useFeatureFlag(flagName: string): boolean {
  const { flags } = useFeatureFlagContext()

  useEffect(() => {
    featureFlagService.setFlagsGetter(() => flags)
  }, [flags])

  return flags[flagName] ?? false
}

export function useAllFeatureFlags(): Record<string, boolean> {
  const { flags } = useFeatureFlagContext()

  useEffect(() => {
    featureFlagService.setFlagsGetter(() => flags)
  }, [flags])

  return flags
}
